import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import * as analytics from 'analytics/Analytics';
import {ANTIBODIES_ANALYTICS_ACTIONS} from 'constants/analytics-products/AntibodiesAnalyticsConstants';
import FileStates from 'FileStates';
import {BioentityPopoverContent} from 'molbio/BioentityPopoverContent';
import Popover from 'ui-library/floating-ui/Popover';

export interface AntibodyComponentPopoverProps {
  antibodyId?: string;
  proteinId: string | null;
  inaccessible: boolean;
  componentLabel: string;
  showPopovers: boolean;
  children: JSX.Element;
}

/**
 * Popover component for antibody domain components that shows protein metadata when provided.
 */
export default function AntibodyComponentPopover({
  antibodyId,
  proteinId,
  inaccessible,
  componentLabel,
  showPopovers,
  children,
}: AntibodyComponentPopoverProps): JSX.Element {
  return (
    <Popover
      isDisabled={!showPopovers}
      renderContent={() => (
        <div className={css(styles.content)}>
          <div className={css(styles.componentLabel)}>{componentLabel}</div>
          {proteinId != null &&
            (inaccessible ? (
              '(No access)'
            ) : (
              <BioentityPopoverContent
                id={proteinId}
                onClickName={() => {
                  FileStates.get().openFolderItem(proteinId);
                  analytics.trackEvent(ANTIBODIES_ANALYTICS_ACTIONS.CLICKED_COMPONENT_CHIP_IN_ANTIBODY_MAP, {
                    antibodyId,
                    componentLabel,
                  });
                }}
                validationExtras={null}
              />
            ))}
        </div>
      )}
    >
      {children}
    </Popover>
  );
}

const styles = StyleSheet.create({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  componentLabel: {
    fontWeight: 600,
    marginLeft: 5,
    alignSelf: 'center',
  },
});
